import {
  BottomSheetHeader as BottomSheetHeaderBase,
  type BottomSheetHeaderProps,
} from "@src/appV2/redesign/system/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function BottomSheetHeader(props: Omit<BottomSheetHeaderProps, "LinkComponent">) {
  return <BottomSheetHeaderBase {...props} LinkComponent={ButtonInternalLink} />;
}
